// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
      apiKey: 'AIzaSyAbPpzyunuu5iu2gF5afcQTZPZBDWjlzCs',
      authDomain: 'rh360-418bf.firebaseapp.com',
      databaseURL: 'https://rh360-418bf.firebaseio.com',
      projectId: 'rh360-418bf',
      storageBucket: 'rh360-418bf.appspot.com',
      messagingSenderId: '608633220998'
  }
};
